import http from '../../../service/axios';
import { IReview } from '../types/Review';
import { ICancelOrderResponse, IOrdersPage } from '../types/Order';

export const orderAPI = {
  getOrders: async () => await http.get('/user/orders'),
  getOrdersPage: async (page: number, perPage: number) =>
    await http.get<IOrdersPage>('/user/orders-paginated', {
      params: { page, per_page: perPage },
    }),
  getActiveOrdersCount: async () =>
    await http.get<{ success: boolean; count: number }>(
      '/order/get-active-orders-count'
    ),
  getOrderById: async (id: string) =>
    await http.get(`/branch/positions2`, {
      params: {
        order_id: id,
      },
      // Названия позиций и подписи статусов бэкенд отдаёт на языке из этого
      // заголовка — как в /branch/list и остальных местах.
      headers: {
        Language: localStorage.getItem('language') || 'uz',
      },
    }),
  review: async (body: IReview) => await http.post('/review/save', body),
  cancelOrder: async (order_id: number) =>
    await http.post<ICancelOrderResponse>('/order/cancel', { order_id }),
  recipt: async (id: string) => await http.get(`/user/qr-data?id=${id}`),
};
